<template>
  <div id="searchField" class="text-body-2 blue lighten-5" @click="gotoSearch">
    Cari event apapun
    <v-icon class="float-right">search</v-icon>
  </div>
</template>

<script>
export default {
  name: 'SearchBar',
  methods: {
    gotoSearch() {
      this.$router.push('/cari-event');
    },
  },
};
</script>

<style scoped>
#searchField {
  padding: 16px;
  margin: 16px;
  border-radius: 5px;
  color: #555555;
}

#searchField:hover {
  cursor: pointer;
  background-color: #ebe8ef;
}
</style>
